import { useTheme } from 'next-themes';
import { useThemeContext } from '../Context/ThemeContext';

/**
 * Custom hook to access current theme colors
 * Usage: const theme = useAppTheme();
 * Then use: theme.bgPrimary, theme.textPrimary, etc.
 */
export const useAppTheme = () => {
  const { themeConfig } = useThemeContext();
  const { resolvedTheme } = useTheme();
  
  return themeConfig[resolvedTheme === 'dark' ? 'dark' : 'light'];
};
